import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    themes: {
      dark: {
        primary: '#162B44',
        secondary: '#72c3a1',
        accent: '#72c3a1',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#6bc091',
        warning: '#FFC107',
      },
      light: {
        primary: '#162B44',
        secondary: '#72c3a1',
        accent: '#72c3a1',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#6bc091',
        warning: '#FFC107',
      },
    },
  },
});
